import { useState } from "react";

import { CtgListData } from "@/components/business/CtgListContainer/ctgList.types";
import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";

import CtgListCheckStatusGuide from "./components/CtgListTableShellForPressTitle/components/CtgListCheckStatusGuide/CtgListCheckStatusGuide";
import CtgListTableShellForCtgTitle from "./components/CtgListTableShellForPressTitle/CtgListTableShellForCtgTitle";

type Props = {
  ctgListItem: CtgListData;
  updateCtgList: () => void;
  ctgListData: CtgListData[];
};

const CtgTitleContainer = ({
  updateCtgList,
  ctgListItem,
  ctgListData,
}: Props) => {
  const [targetCtgId, setTargetCtgId] = useState(0);
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleTargetCtgId = (id: number) => {
    setTargetCtgId(id);
  };

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  return (
    <>
      <CtgListTableShellForCtgTitle
        key={ctgListItem.id}
        ctgData={ctgListItem}
        openCheckStatusModal={openCheckStatusModal}
        handleTargetCtgId={() => handleTargetCtgId(ctgListItem?.id || 0)}
        handleCurrentStatus={handleCurrentStatus}
      />

      {isCheckStatusModal && (
        <CtgListCheckStatusGuide
          closeModal={closeCheckStatusModal}
          draftArticleId={targetCtgId}
          updateCtgList={updateCtgList}
          ctgListData={ctgListData || []}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default CtgTitleContainer;
